const profileLanguages = [
    {
        "EnglishName": "System Default",
        "IetflanguageTag": "",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 0,
        "LocalName": "System Default"
    },
    {
        "EnglishName": "English",
        "IetflanguageTag": "en-US",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 1,
        "LocalName": "English"
    },
    {
        "EnglishName": "German",
        "IetflanguageTag": "de",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 2,
        "LocalName": "Deutsch"
    },
    {
        "EnglishName": "Portuguese",
        "IetflanguageTag": "pt",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 3,
        "LocalName": "Portuguese"
    },
    {
        "EnglishName": "French",
        "IetflanguageTag": "FR",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 4,
        "LocalName": "French"
    },
    {
        "EnglishName": "Italian",
        "IetflanguageTag": "IT",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 5,
        "LocalName": "Italian"
    },
    {
        "EnglishName": "Dutch",
        "IetflanguageTag": "NL",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 6,
        "LocalName": "Dutch"
    },
    {
        "EnglishName": "Spanish",
        "IetflanguageTag": "ES",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 7,
        "LocalName": "Spanish"
    },
    {
        "EnglishName": "Turkish",
        "IetflanguageTag": "TR",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 8,
        "LocalName": "Turkish"
    },
    {
        "EnglishName": "Polish",
        "IetflanguageTag": "pl",
        "IsDefaultForLanguageCode": false,
        "LanguageCode": null,
        "LanguageId": 9,
        "LocalName": "Polish"
    }
]

export default profileLanguages;